module.exports = __webpack_public_path__ + "static/code2-fa8e43972617756cf25055ac9514c1a5.png";